import script from "./QuickAddButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuickAddButton.vue?vue&type=script&lang=ts&setup=true"

import "./QuickAddButton.vue?vue&type=style&index=0&id=263ce81e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-263ce81e"]])

export default __exports__